/**
 * Sheet: https://docs.google.com/spreadsheets/d/1RCSWKnlaofIN2gcmLBPiadCpEnJfrW1cglvR_e_jRJ4/edit?usp=sharing
 */

function PcJourney(debug = false) {
  let docCookies = window.docCookies;
  const _COOKIE_NAME = 'pc_journey';
  const _LAST_MODIFIED_STRING = 'lastModified';
  const _FORMS_COMPLETED_STRING = 'formsCompleted';
  const _COMPANY_TYPE_STRING = 'companyType';
  const _FUNNEL_TIER_STRING = 'funnelTier';
  const _DEFAULT_CONFIG = `${_LAST_MODIFIED_STRING}=${new Date().toString()};${_FORMS_COMPLETED_STRING}=;${_COMPANY_TYPE_STRING}=;${_FUNNEL_TIER_STRING}=0;`.replace(
    / /g,
    '+'
  );

  /****************************************************
   * PRIVATE METHODS
   **************************************************** /

  /**
   * @purpose Checks for the _COOKIE_NAME cookie and creates it if it doesn't exist.
   */
  let _init = () => {
    let pcJourneyCookie = docCookies.getCookie(_COOKIE_NAME);
    !pcJourneyCookie && docCookies.setCookie(_COOKIE_NAME, encodeURIComponent(_DEFAULT_CONFIG));
  };

  /**
   * @purpose Converts the cookie string into an object
   */
  let _getCookieAsObject = () => {
    let cookie = decodeURIComponent(docCookies.getCookie(_COOKIE_NAME));
    let map = {};

    cookie
      .split(';')
      .filter(Boolean)
      .forEach(value => {
        map[value.split('=')[0].trim()] = value.split('=')[1].trim() || '';
      });

    return map;
  };

  /**
   * @purpose Updates the _COOKIE_NAME cookie
   * @param {*} key
   * @param {*} value
   */
  let _updateCookie = (key, value) => {
    let cookieString = '';
    let object = _getCookieAsObject();

    logger.debug(`Object before update: ${JSON.stringify(object)}`);
    object[_LAST_MODIFIED_STRING] = new Date().toString().replace(/ /g, '+');
    object[key] = value;
    logger.debug(`Object after update: ${JSON.stringify(object)}`);

    Object.keys(object).forEach(key => {
      cookieString += `${key}=${object[key]};`;
    });

    logger.debug(`Updating cookie to '${cookieString}' prior to encoding`);
    docCookies.setCookie(_COOKIE_NAME, encodeURIComponent(cookieString));
  };

  /**
   * @purpose Updates the funnel tier on formCompleted update
   * @param {*} tier
   */
  let _setFunnelTier = (tier = 0) => {
    logger.debug(`Setting funnel tier to ${tier}`);
    _updateCookie(_FUNNEL_TIER_STRING, tier);
  };

  /****************************************************
   * PUBLIC METHODS
   ****************************************************/

  /**
   * @purpose Get the value in the cookie in a JSON
   * @param {*} key
   */
  let getDataObject = (key = '') => {
    let object = _getCookieAsObject();
    logger.debug(`Obtaining cookie as an object: '${JSON.stringify(object)}'`);

    if (key) {
      logger.debug(`Returning value for '${key}' as '${object[key]}'`);
      return object[key];
    } else {
      logger.debug(`Returning entire object back since no key provided`);
      return object;
    }
  };

  /**
   * @purpose Update the formsCompleted part of the cookie with a new form id/code
   * @param {*} id
   */
  let setFormCompleted = (id = '') => {
    if (!id) {
      logger.debug('No form id was provided, returning null');
      return null;
    } else {
      let formsCompleted = _getCookieAsObject()[_FORMS_COMPLETED_STRING] || '';
      logger.debug(`A form id of '${id}' was provided. Obtaining formsCompleted as a string: '${formsCompleted}'`);

      if (formsCompleted.indexOf(id) === -1) {
        logger.debug(`Form ${id} does not exist in the cookie - setting`);
        formsCompleted = `${formsCompleted},${id}`;
        formsCompleted = formsCompleted[0] == ',' ? formsCompleted.slice(1) : formsCompleted;
        _updateCookie(_FORMS_COMPLETED_STRING, formsCompleted);
      } else {
        logger.debug(`Form ${id} exists in the cookie - not setting`);
        return false;
      }

      _setFunnelTier(id[0]);
    }
  };

  /**
   * @purpose Get the formsCompleted string value or a boolean if an id exists
   * @param {*} id
   */
  let getFormsCompleted = id => {
    const formsCompleted = _getCookieAsObject()[_FORMS_COMPLETED_STRING];

    if (id) {
      const exists = formsCompleted.indexOf(id) !== -1;
      logger.debug(`Id ${exists ? 'DOES' : "DOESN'T"} exist in the cookie`);
      return exists;
    } else {
      logger.debug(`No id provided, returning string value for formsCompleted`);
      return formsCompleted;
    }
  };

  /**
   * @purpose Returns a funnel tier level based on which forms were completed (Group Number e.g. 1.# 2.# 3.# families)
   */
  let getFunnelTier = () => {
    const formsCompleted = _getCookieAsObject()[_FORMS_COMPLETED_STRING];
    logger.debug(`Determing funnel based on formsCompleted: '${formsCompleted}'`);

    if (formsCompleted.toString().indexOf('3.') !== -1) {
      logger.debug('User is bottom of funnel');
      return 3;
    } else if (formsCompleted.toString().indexOf('2.') !== -1) {
      logger.debug('User is mid of funnel');
      return 2;
    } else if (formsCompleted.toString().indexOf('1.') !== -1) {
      logger.debug('User is top of funnel');
      return 1;
    } else {
      return 0;
    }
  };

  let setCompanyType = (companyType = '') => {
    logger.debug(`Updating company type to '${companyType}'`);
    _updateCookie(_COMPANY_TYPE_STRING, companyType.toLowerCase().replace(/ /g, '-'));
  };

  let getCompanyType = () => {
    const companyType = _getCookieAsObject()[_COMPANY_TYPE_STRING];
    logger.debug(`Returning company type of "${companyType}"`);
    return companyType;
  };

  let getIndependentExperienceCookies = () => {
    logger.debug('Returning all independent experience cookies and their exists/values.');
    return {
      pc_tour_pass: {
        exists: document.cookie.indexOf(`pc_tour_pass=`) != -1,
        value: docCookies.getCookie('pc_tour_pass') || null
      },
      pc_gbk_live_pass: {
        exists: document.cookie.indexOf(`pc_gbk_live_pass=`) != -1,
        value: docCookies.getCookie('pc_gbk_live_pass') || null
      }
    };
  };

  _init();

  this.getDataObject = getDataObject;
  this.setFormCompleted = setFormCompleted;
  this.getFormsCompleted = getFormsCompleted;
  this.setCompanyType = setCompanyType;
  this.getCompanyType = getCompanyType;
  this.getFunnelTier = getFunnelTier;
  this.getIndependentExperienceCookies = getIndependentExperienceCookies;
}

module.exports = new PcJourney();
